/**
 * The phone's top row, in flow: the Go box, the update chip (only after a
 * deploy), the status dot (a popover with the
 * text and Retry), the avatar (menu opens downward) and — until the dock is
 * promoted in step 7 — the chat toggle. Hidden at the nav breakpoint and above.
 */
import React from 'react';

import { GlobalChatToggle } from '@shared/components/chat/dock/GlobalChatToggle';

import GoBox from '../SideNav/GoBox';
import SideNavProfile from '../SideNav/SideNavProfile';
import StatusLine from '../SideNav/StatusLine';
import UpdateChip from '../SideNav/UpdateChip';

const MobileTopRow: React.FC = () => (
  <header className="bg-sidebar text-sidebar-foreground border-border nav:hidden pt-safe flex shrink-0 items-center gap-1 border-b px-2 py-1.5">
    {/* No `onNavigate`: there is no drawer to close any more. */}
    <div className="min-w-0 flex-1">
      <GoBox isCollapsed={false} />
    </div>
    <UpdateChip compact />
    <StatusLine isCollapsed pinnedCollapsed={false} variant="popover" />
    <SideNavProfile isCollapsed placement="below" />
    <GlobalChatToggle className="p-1.5" />
  </header>
);

export default MobileTopRow;
